import {
	Card,
	makeStyles,
	Tooltip,
	IconButton,
	Dialog,
	DialogTitle,
	DialogActions,
	DialogContent,
	Button,
	Box,
} from '@material-ui/core';
// import { DataGrid } from "@material-ui/data-grid";
import * as dayjs from 'dayjs';
import React from 'react';
import { useActions, useValues } from 'kea';
import EditIcon from "@material-ui/icons/Edit";
import Form from "@rjsf/material-ui";
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { rmovementlogic } from 'src/store/report';
import prettytime from 'src/utils/prettytime';
import IgnitionDataDialog from './AddDataDialogs/IgnitionDialog';
// import CSVDialog from './CSVDialog';
// import PDFDialog from './PDFDialog';
import { formSchema, uiSchema } from './schema';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';

import triplogic from 'src/store/trip';

const useStyles = makeStyles({
	root: {
		width: "100%",
		height: '631px'
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		name: 'event',
		label: 'Event',
		align: 'left',
		width: 130,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	// {
	// 	name: 'date',
	// 	label: 'Date',
	// 	align: 'left',
	// 	width: 110,
	// 	options: {
	// 		customBodyRender: (param) => withTooltip(param)
	// 	}
	// },
	{
		name: 'start_time',
		label: 'Start Time',
		align: 'left',
		width: 150,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'stop_time',
		label: 'Finish Time',
		align: 'left',
		width: 150,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'from_location',
		label: 'From Location',
		align: 'left',
		width: 240,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'to_location',
		label: 'To Location',
		align: 'left',
		width: 240,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'distance_travelled',
		label: 'Distance',
		align: 'left',
		width: 150,
		sort: false,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'event_time',
		label: 'Duration',
		align: 'left',
		width: 140,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'notes',
		label: 'Journey',
		align: 'left',
		width: 250,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		noprint: true,
		name: 'body',
		label: 'Edit',
		align: 'left',
		width: 120,
		options: {
			filter: false,
			customBodyRender: (param) => {
				return <>
					<Tooltip title='Edit Notes' >
						<IconButton size='small' aria-label="delete" onClick={param}>
							<EditIcon color="primary" />
						</IconButton>
					</Tooltip>
				</>
			}
		}
	}
];

const initialRowsPerPage = 10;


const Movement = () => {
	// const classes = useStyles();
	const { trips, vehicle, query } = useValues(rmovementlogic);
	const { update } = useActions(triplogic);
	const [data, setData] = React.useState([]);

	const [trip, setTrip] = React.useState({});
	const [tripEdit, setTripEdit] = React.useState(false);

	const handleEditNotes = (trip) => () => {
		setTrip(trip);
		setTripEdit(true);
	}

	const handleNotesSubmit = ({ formData }) => {
		update(formData);
		setTripEdit(false);
	}

	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})


	React.useEffect(() => {
		// console.log('running')
		if (trips.length > 0) {
			let newRows = trips.map((row, count) => {
				let tolocation = row.stop.address.split(' ')
				tolocation.splice(tolocation.length - 2, 1)

				let fromlocation = row.start.address.split(' ')
				fromlocation.splice(fromlocation.length - 2, 1)

				let eventtime = prettytime(row.duration);

				return {
					id: count,
					event: row.event,
					start_time: `${dayjs(row.start_time).format('h:mm a DD MMM YY')}`,
					stop_time: `${dayjs(row.stop_time).format('h:mm a DD MMM YY')}`,
					// date: `${dayjs(row.start_time).format('DD MMM YY')} - ${dayjs(row.stop_time).format('DD MMM YY')}`,
					// time: `${dayjs(row.start_time).format('h:mm a')} - ${dayjs(row.stop_time).format('h:mm a')}`,
					// ignition_off_timestamp: `${dayjs(row.ignition_off_timestamp).format('HH:mm  DD MMM YY')}`,
					to_location: tolocation.join(' '),
					from_location: fromlocation.join(' '),
					distance_travelled: `${row.distance / 1000} KM(s)`,
					event_time: eventtime,
					body: handleEditNotes(row),
					notes: `${row.type || ''}${row.type ? ': ' : ''}${row.body || ''}`,
				}
			});
			setData(newRows);
		} else {
			setData([])
		}
	}, [trips]);

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				{/* <br /> */}
				<PrintToolbarPlugin
					title='Movement Report'
					context={{
						head: [['Vehicle Name', 'Registration', 'State', 'Make', 'Model', 'Year', 'Color', 'Start Time', 'End Time']],
						body: [[vehicle?.name, vehicle?.registration_number, vehicle?.registration_state, vehicle?.company, vehicle?.model, vehicle?.year, vehicle?.color, dayjs(query?.start).format('DD-MM-YYYY HH-mm'), dayjs(query?.stop).format('DD-MM-YYYY HH-mm')]]
					}}
					rows={data}
					columns={columns}
					filename={`Movement_Report ${vehicle?.name.replaceAll(' ', '_')} [${dayjs(query?.start).format('YYYY-MM-DD HH-mm')}-to-${dayjs(query?.stop).format('YYYY-MM-DD HH-mm')}]`}
				/>
				<CSVToolbarPlugin rows={data} columns={columns} filename={`Movement_Report ${vehicle?.name.replaceAll(' ', '_')} [${dayjs(query?.start).format('YYYY-MM-DD HH-mm')}-to-${dayjs(query?.stop).format('YYYY-MM-DD HH-mm')}]`} />
				<IgnitionDataDialog />
			</span>
	};

	return (
		<div>
			<Dialog
				open={tripEdit}
				onClose={() => setTripEdit(false)}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Edit Journey <br />
					<a target="_blank" href='https://www.ato.gov.au/Business/Income-and-deductions-for-business/Deductions/Deductions-for-motor-vehicle-expenses/Logbook-method/'>
						Click here to learn more.
					</a>
				</DialogTitle>
				<DialogContent>
					<Form
						schema={formSchema}
						onSubmit={handleNotesSubmit}
						uiSchema={uiSchema}
						formData={trip}
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} variant="contained" color="primary">
								Save
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
			<Box mt={1}>

				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Movement Report" + (vehicle ? `: ${vehicle.name} - ${vehicle.registration_number}` : '')}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</div>
	);
};


export default Movement;
